import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import image from "../assets/azure.jpeg"
import RatingStars from "../components/common/RatingStars";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineGlobeAlt } from "react-icons/hi";
import CourseDetailsCardAzure from "../components/core/Course/CourseDetailsCardAzure";
import ReactMarkdown from "react-markdown";
import { BsFillCaretRightFill, BsFillCaretRightSquareFill } from "react-icons/bs";
import CourseAccordionBar from "../components/core/Course/CourseAccordionBar"
import Footer from "../components/common/Footer";

const CourseDetails = () => {
  const [isActive, setIsActive] = useState(Array(0));
  const handleActive = () => {
    // console.log("called", id)
    setIsActive(

    );
  };

  return (
    <>
      <div className={`relative w-full bg-richblue-5`}>
        <div className="mx-auto box-content px-4 lg:w-[1260px] 2xl:relative ">
          <div className="mx-auto grid min-h-[450px] max-w-maxContentTab justify-items-center py-8 lg:mx-0 lg:justify-items-start lg:py-0 xl:max-w-[810px]">
            <div className="relative block max-h-[30rem] lg:hidden">
              <div className="absolute bottom-0 left-0 h-full w-full shadow-[#161D29_0px_-64px_36px_-28px_inset]"></div>
              <img
                src={image}
                alt="course thumbnail"
                className="aspect-auto w-full"
              />
            </div>

            <div
              className={`z-30 my-5 flex flex-col justify-center gap-4 py-5 text-lg text-richblue-700`}
            >
              <div>
                <p className="text-4xl font-bold text-richblue-700 sm:text-[42px]">
                  AZ-304: Microsoft Azure Architect Design Certification Training
                </p>
              </div>

              <p className={`text-richblue-500`}>
              With the increasing adoption of cloud technologies and the need for scalable, secure, and cost-efficient solutions, the AZ-304: Microsoft Azure Architect Design Certification has emerged as a globally recognized standard for cloud architecture expertise. This course is meticulously crafted to provide professionals with a comprehensive understanding of Azure services, architectural best practices, and cloud solution design principles.<br></br>
              By mastering Azure Architect methodologies, participants gain the ability to design, deploy, and manage robust cloud infrastructures with precision and efficiency. 
              </p>
              <div className="text-md flex flex-wrap items-center gap-2">
                <span className="text-yellow-25">5</span>
                <RatingStars Review_Count={5} Star_Size={20} />
                <span>{`(${5} reviews)`}</span>
                <span> | </span>
                <span>{`${200}+ Professionals Enrolled`}</span>
              </div>

              <div className="flex flex-wrap gap-5 text-lg">
                <p className="flex items-center gap-2">
                  {" "}
                  <BiInfoCircle /> Created at February 15, 2024 | 8:01 PM
                </p>
                <p className="flex items-center gap-2">
                  {" "}
                  <HiOutlineGlobeAlt /> English
                </p>
              </div>
            </div>
            <div className="flex w-full flex-col gap-4 border-y border-y-richblue-300 py-4 lg:hidden">
              <p className="space-x-3 pb-4 text-3xl font-semibold text-richblue-700">
                Rs. {19999}
              </p>
              <button className="yellowButton">Enroll Now</button>
              <button className="blackButton">Request Free Demo</button>
            </div>
          </div>
          {/* Courses Card */}
          <div className="right-[2rem] top-[60px] mx-auto hidden min-h-[600px] w-1/3 max-w-[410px] translate-y-24 md:translate-y-0 lg:absolute  lg:block">
            <CourseDetailsCardAzure />
          </div>
        </div>
      </div>
      <div className="mx-auto box-content px-4 text-start text-richblue-700 lg:w-[1260px]">
        <div className="mx-auto max-w-maxContentTab lg:mx-0 xl:max-w-[810px]">
          {/* What will you learn section */}
          <div className="my-8 border border-richblue-300 p-8">
            <p className="text-3xl font-semibold">Course Overview</p>
            <div className="mt-5">
              <ReactMarkdown>
                {
                  "In today’s rapidly evolving digital landscape, organizations are increasingly adopting cloud technologies to drive innovation, scalability, and cost efficiency. The growing complexity of cloud architectures and the need for secure, high-performing solutions have made it essential for professionals to master cloud design and implementation best practices."
                }
              </ReactMarkdown>
              <ReactMarkdown>
                {
                  "The AZ-304: Microsoft Azure Architect Design Certification Training is designed to address these challenges by providing professionals with a comprehensive understanding of Azure services, architectural principles, and cloud solution design. This course equips participants with the knowledge and skills to design, deploy, and manage scalable, secure, and cost-optimized cloud infrastructures using Microsoft Azure."
                }
              </ReactMarkdown>
            </div>
            <p className="text-3xl font-semibold mt-5">What you'll learn</p>
            <div className="flex flex-col gap-3 mt-5">
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Design solutions for the Microsoft Azure platform with confidence.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Master core Azure concepts to architect solutions for organizational needs.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Prepare effectively to pass the AZ-304 Azure Architect Design exam.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Discover and leverage enterprise data assets using Azure Catalog.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Design scalable, secure, and cost-efficient cloud architectures.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Implement high-performing and fault-tolerant systems on Azure.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Explore Azure security, compliance, and governance best practices.
                </span>
              </p>
            </div>
          </div>

          {/* Course Content Section */}
          <div className="max-w-[830px] ">
            <div className="flex flex-col gap-3">
              <p className="text-[28px] font-semibold">Course Curriculum</p>
              <div className="flex flex-wrap justify-between gap-2">
                <div className="flex gap-2">
                  <span>
                    {8} {`module(s)`} &nbsp; |
                  </span>
                  <span>
                    {27} {`lecture(s)`} &nbsp; |
                  </span>
                  <span>{"1h 10m"} total length</span>
                </div>
                <div>
                  <button
                    className="text-yellow-25"
                    onClick={() => setIsActive([])}
                  >
                    Collapse all sections
                  </button>
                </div>
              </div>
            </div>

            {/* Course Details Accordion */}
            <div className="py-4 ">
              <CourseAccordionBar
                courseName={"Module 1: Introduction to Azure and Cloud Architecture"}
                courseList={[
                  "Overview of Microsoft Azure and its global infrastructure",
                  "Key concepts of cloud computing and architecture",
                  "Benefits of adopting Azure for scalable and secure solutions"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 2: Designing for Identity, Security, and Governance"}
                courseList={[
                  "Implementing Azure Active Directory (AD) for identity management",
                  "Designing secure access to Azure resources using RBAC and policies",
                  "Implementing governance solutions with Azure Policy and Blueprints",
                  "Securing data and applications using Azure Security Center"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 3: Designing Data Storage Solutions"}
                courseList={[
                  "Choosing the right Azure storage solution (e.g., Blob, Files, Disks)",
                  "Designing data storage strategies for scalability and performance",
                  "Implementing data redundancy and backup solutions",
                  "Using Azure SQL Database and Cosmos DB for data management"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 4: Designing Business Continuity and Disaster Recovery"}
                courseList={[
                  "Designing solutions for high availability and fault tolerance",
                  "Implementing disaster recovery strategies with Azure Site Recovery",
                  "Understanding Recovery Time Objective (RTO) and Recovery Point Objective (RPO)",
                  "Designing backup and restore solutions for Azure workloads"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 5: Designing Infrastructure Solutions"}
                courseList={[
                  "Designing virtual networks (VNets) and network security groups (NSGs)",
                  "Implementing hybrid connectivity with Azure ExpressRoute and VPN Gateway",
                  "Designing compute solutions using Azure Virtual Machines and App Services",
                  "Optimizing infrastructure for performance and cost efficiency"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 6: Designing for Deployment, Migration, and Integration"}
                courseList={[
                  "Planning and implementing workload migrations to Azure",
                  "Using Azure Migrate for assessment and migration",
                  "Designing CI/CD pipelines with Azure DevOps",
                  "Integrating Azure services with on-premises and third-party solutions"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />

              <CourseAccordionBar
                courseName={"Module 7: Monitoring, Optimization, and Cost Management"}
                courseList={[
                  "Designing monitoring solutions with Azure Monitor and Log Analytics",
                  "Optimizing Azure workloads for performance and cost",
                  "Implementing cost management strategies using Azure Cost Management",
                  "Analyzing and optimizing resource utilization"
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
            </div>


          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CourseDetails;
